export const ADMIN_METAL_COST_PREFIX = 'adminMetalCost';
export const GET_ADMIN_METAL_COST = `${ADMIN_METAL_COST_PREFIX}/getMetalCosts`;
export const ADD_ADMIN_METAL_COST = `${ADMIN_METAL_COST_PREFIX}/addMetalCost`;
export const STOP_ADMIN_METAL_COST = `${ADMIN_METAL_COST_PREFIX}/stopMetalCost`;
export const UPLOAD_ADMIN_METAL_COST_TEMPLATE = `${ADMIN_METAL_COST_PREFIX}/uploadTemplate`;
export const DELETE_ADMIN_METAL_COST_TEMPLATE = `${ADMIN_METAL_COST_PREFIX}/deleteTemplate`;
export const CHECK_ADMIN_METAL_COST_FILELINK = `${ADMIN_METAL_COST_PREFIX}/checkFilelink`;
